export const colors = {
    white: "#ffffff",
    dark: "#3B3B3B",
    brandDark: "#1D2257",
    brandMid: "#3463F4",
    brandLight: "#7DF0E5",
    brandXLight: "#EAEAFF",
    brandXXLight: "#F7F7FC",
    brandXXXLight: "#f0f3fe",
    text: "#3B3B3B",
};